export default __webpack_public_path__ + "static/media/ic_barbados.b21f022f.svg";